import React from 'react'
import find from 'ramda/es/find'
import compose from 'ramda/es/compose'
import propEq from 'ramda/es/propEq'
import propOr from 'ramda/es/propOr'

const findTicketById = match => find(propEq('id', match))
const getTicketTitle = propOr('', 'ticket_title')

const getTicketName = findTicket =>
  compose(
    getTicketTitle,
    findTicket
  )

const ServiceStudentsSelectorServiceOverview = ({
  order: {
    service_ticket: selectedTicketId,
    service: { title: serviceTitle, tickets },
  } = {},
}) => {
  const ticketFinder = findTicketById(selectedTicketId)

  return (
    <section className="service-students-selector-overview">
      <h4>انتخاب دانش آموزان جهت {serviceTitle}</h4>
      <h5>{getTicketName(ticketFinder)(tickets)}</h5>
    </section>
  )
}

export default ServiceStudentsSelectorServiceOverview



// WEBPACK FOOTER //
// ./src/components/common/Services/ServiceStudentsSelector/ServiceStudentsSelectorServiceOverview.js